import { Formik, Form, ErrorMessage } from 'formik'
import { sanitizeFormInput, sanitizeFormOutput } from '../../functions/formFunctions'
import WrapperAccordion from '../general/WrapperAccordion';
import { EDIT_NEWSLETTER_CAP } from '../../constants/caps';
import FieldWrapper from './FieldWrapper';
import ButtonSubmitCancel from '../general/ButtonSubmitCancel';
import { TextEditor } from './fields/TextEditor';
import { withRouter } from 'react-router-dom';

const toolbarSettings = {
    options: ['fontSize', 'link'],
}

const FormNewsletterElementText = ({
    itemData,
    closePagePath,
    onUpdateItem,
    history
}) => {
    return (
        <Formik
            initialValues={sanitizeFormInput(itemData)}
            onSubmit={(values, actions) => {
                onUpdateItem('texts', sanitizeFormOutput(values))
                history.push(closePagePath)
            }}
            
            onReset={(values, actions) => {
                history.push(closePagePath)
            }}
        >
        {({ values, errors, status, touched, isSubmitting, handleReset, setFieldValue }) => (
                <Form>
                    <WrapperAccordion
                        className="single-section"
                        selectionActiveClass="accordion-item-open"
                    >
                        <fieldset>
                            <div className="form-content highlight">
                                <div className="left-sections">
                                        <FieldWrapper label="" id="text" classes="field-textarea field-textarea-text">
                                            <TextEditor
                                                setFieldValue={(val) => setFieldValue("text", val)}
                                                value={values.text}
                                                toolbar={toolbarSettings}
                                            />
                                            <ErrorMessage className="text-regular-color" name="text" component="div" /> 
                                        </FieldWrapper>
                                </div>
                            </div>
        
                            <ButtonSubmitCancel
                                transIdCancel="cancel_button"
                                transIdSubmit="save_item_button"
                                cap={EDIT_NEWSLETTER_CAP}
                                disabledCancel={isSubmitting}
                                disabledSubmit={isSubmitting}
                                onCancel={handleReset}
                            />
                        </fieldset>
                    </WrapperAccordion>
                </Form>
            )}

        </Formik>
    )

}

export default withRouter(FormNewsletterElementText)